//@ts-nocheck
import React, { useEffect, useState } from 'react'

import { useNavigate, useParams } from 'react-router-dom';
import { getColorForLabel } from '../../../../utils/colorUtils';
import { ExclamationIcon } from '../../../../components/icons';
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { _baseRequest, COMMON } from '../../../../utils/baseApi';



function BillingInvoice() {
  const { baseId, jobId } = useParams<{ baseId: string; jobId: string; }>();
  const [allTaskItem, setAllTaskItem] = useState({
    InvoiceList: [],
    totalTask: 0,
    currentPage: 1,
    hasNextPage: false,
    limit: 25,
    totalInvoice: 1
  });
  const [isLoading, setIsLoading] = useState(false);
  const userDetailsData = localStorage.getItem('jobByHiringTeamMembers');
  const baseMembers = userDetailsData ? JSON.parse(userDetailsData) : [];
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const navigate = useNavigate()

  const getSenderDetails = (item) => {
    // Default return object
    const defaultDetails = {
      image: null,
      name: null
    };

    if (item.assigned_to) {
      const senderUser = baseMembers.find(member => member.user_id === item.assigned_to) || {};
      return {
        image: senderUser.profile_pic || null,
        name: senderUser.name || null
      };
    }

    return defaultDetails;
  };

  const downloadInvoice = (invoice) => {
    // Create an HTML representation of the invoice that we'll convert to PDF
    const generateInvoiceHTML = () => {
  const formatDate = (dateString) => {
      const date = new Date(dateString);
      return `${date.getDate()} ${date.toLocaleString('default', { month: 'short' })}, ${date.getFullYear()}`;
    };

    // Get current date
    const today = new Date();
    const currentDate = formatDate(today);

    // Format invoice date
    const invoiceDate = invoice.createdDate ? formatDate(invoice.createdDate) : currentDate;
    
    // Use actual billing period from API
    const billingPeriod = `${formatDate(invoice.dateFrom)} - ${formatDate(invoice.dateTill)}`;

    // Generate invoice number using the actual ID
    const invoiceNumber = `INV-${invoice.id.toUpperCase()}`;

    // Logo URL
    const logoUrl = `${process.env.REACT_APP_API_BASE_URL}/public/assets/teamer-logo.png`;

    // Format currency
    const formatCurrency = (amount, currency) => {
      const currencySymbols = {
        'Dollar': '$', 'USD': '$',
        'Euro': '€', 'EUR': '€',
        'Pound': '£', 'GBP': '£',
        'Rupee': '₹', 'INR': '₹'
      };
      const symbol = currencySymbols[currency] || '$';
      return `${symbol}${parseFloat(amount || 0).toFixed(2)}`;
    };

    // Calculate values from API response
    const billableAmount = parseFloat(invoice.billableAmount || 0);
    const discountAmount = parseFloat(invoice.discount || 0);
    const netAmount = parseFloat(invoice.netAmount || 0);

    // Calculate usage details
    const totalUsage = (invoice.member || 0) + (invoice.application || 0) + (invoice.ai || 0) + (invoice.jobs || 0);
    const extraUsage = (invoice.extraUser || 0) + (invoice.extraApplication || 0) + (invoice.extraAi || 0) + (invoice.jobsExtra || 0);

    // Calculate billing period in months
    const startDate = new Date(invoice.dateFrom);
    const endDate = new Date(invoice.dateTill);
    const diffTime = Math.abs(endDate - startDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    const billingMonths = (diffDays / 30.44).toFixed(2); // Average days per month


      // Create a styled HTML document for the invoice based on the provided image
      const htmlContent = `
        <!DOCTYPE html>
        <html>
        <head>
          <title>Invoice ${invoiceNumber}</title>
          <style>
            body {
              font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
              margin: 0;
              padding: 40px;
              color: #333;
              line-height: 1.4;
            }
            .invoice-container {
              max-width: 800px;
              margin: 0 auto;
            }
            .logo {
              color: #0088ff;
              font-size: 28px;
              font-weight: bold;
              margin-bottom: 5px;
            }
            .logo-icon {
              display: inline-block;
              color: #0088ff;
              font-weight: bold;
            }
            .invoice-title {
              font-size: 14px;
              margin-bottom: 30px;
              font-weight: 600
            }
            .section {
              margin-bottom: 60px;
            }
            .grid {
              display: flex;
              justify-content: space-between;
            }
            .col {
              flex: 1;
            }
            .right-align {
              text-align: right;
            }
            .label {
              font-weight: 600;
              color: #000;
              margin-bottom: 5px;
            }
            .value {
              margin-bottom: 10px;
              color: #4b5563
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 10px;
              margin-bottom: 20px;
            }
            th, td {
              text-align: left;
              padding: 10px 0;
              border-bottom: 1px solid #eee;
            }
            th {
              color: #666;
              font-weight: normal;
            }
            td.number, th.number {
              text-align: right;
            }
            .summary {
              margin-top: 20px;
            }
            .total {
              font-weight: bold;
              margin-top: 10px;
              padding-top: 10px;
              border-top: 1px solid #eee;
            }
              .image-logo {
              width: 24px;
              height: 24px;
              border-radius: 5px;
              object-fit: cover;
            }
              .image-text{
              overflow: hidden; 
width: 100%; 
font-weight: 600; 
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap; 
text-overflow: ellipsis; 
white-space: nowrap; 
cursor: pointer; 
color: 0.8125rem;
max-width: 160px;

              }
.logo-details{
display: flex; 
align-items: center; 
width: 100%; 
cursor: pointer; 
height: 32px;
gap: 8px
}
          </style>
        </head>
        <body>
          <div class="invoice-container">
           <div class='logo-details'>
                    <img
                      class="image-logo"
                      src="${logoUrl}"
                      alt="base logo"
                    />


                    <span class="image-text">teamer</span>
                  </div>
            <div class="invoice-title">
              Final Invoice for the ${billingPeriod} billing period
            </div>
            
            <div class="grid section">
              <div class="col">
                <div class="label">From</div>
                <div class="value">
                  Riscom<br>
                  C4/9 - SECTOR O EXTENSION<br>
                  MANSAROVAR, KANPUR ROAD<br>
                  YOJNA Lucknow, UP 226012<br>
                  INDIA<br><br>
                  Tax ID: 23AAHCR6900N1Z6
                </div>
              </div>
              
              <div class="col">
                <div class="label">Details</div>
                <div class="value">
                  <table style="border: none; width: 100%;">
                    <tr>
                      <td style="border: none; padding: 2px 0;">Invoice number:</td>
                      <td style="border: none; padding: 2px 0; text-align: right;">${invoiceNumber}</td>
                    </tr>
                    <tr>
                    <td style="border: none; padding: 2px 0;">Base ID:</td>
                    <td style="border: none; padding: 2px 0; text-align: right;">${invoice.base_id}</td>
                  </tr>
                
                      <tr>
                    <td style="border: none; padding: 2px 0;">Plan ID:</td>
                    <td style="border: none; padding: 2px 0; text-align: right;">${invoice.pricingPlanId}</td>
                  </tr>
                      <tr>
                    <td style="border: none; padding: 2px 0;">Invoice Date:</td>
                    <td style="border: none; padding: 2px 0; text-align: right;">${invoiceDate}</td>
                  </tr>
                     <tr>
                    <td style="border: none; padding: 2px 0;">Status:</td>
                    <td style="border: none; padding: 2px 0; text-align: right;">
                      <span class="status-badge status-${invoice.status?.toLowerCase() || 'pending'}">${invoice.status || 'Pending'}</span>
                    </td>
                  </tr>
                    <tr>
                    <td style="border: none; padding: 2px 0;">Payment Method:</td>
                    <td style="border: none; padding: 2px 0; text-align: right;">${invoice.payment_method || 'Not specified'}</td>
                  </tr>
                    ${invoice.payment_id ? `
                  <tr>
                    <td style="border: none; padding: 2px 0;">Payment ID:</td>
                    <td style="border: none; padding: 2px 0; text-align: right;">${invoice.payment_id}</td>
                  </tr>
                  ` : ''}
                  ${invoice.paymentDate ? `
                  <tr>
                    <td style="border: none; padding: 2px 0;">Payment Date:</td>
                    <td style="border: none; padding: 2px 0; text-align: right;">${formatDate(invoice.paymentDate)}</td>
                  </tr>
                  ` : ''}
                  </table>
                </div>
              </div>
            </div>
            
            <div class="section">
              <div class="label">For</div>
              <div class="value">
                Mission Internet Private Limited<br>
                255, PU4, Indore, MP, 452015<br>
                India
              </div>
            </div>
            
            <div class="section">
            <div class="label">Billing Summary</div>
              <table>
                  <tr>
                <td>Billing Period</td>
                <td class="number">${billingPeriod}</td>
              </tr>
                 <tr>
                <td>Total Usage Units</td>
                <td class="number">${totalUsage + extraUsage}</td>
              </tr>
              <tr>
                <td>Billable Amount</td>
                <td class="number">${formatCurrency(billableAmount, invoice.currency)}</td>
              </tr>
            
               ${discountAmount > 0 ? `
              <tr>
                <td>Discount Applied</td>
                <td class="number">-${formatCurrency(discountAmount, invoice.currency)}</td>
              </tr>
              ` : ''}
              <tr class="total">
                <td><strong>Net Amount</strong></td>
                <td class="number"><strong>${formatCurrency(netAmount, invoice.currency)}</strong></td>
              </tr>
              </table>
            </div>
          </div>
        </body>
        </html>
      `;

      return htmlContent;
    };

    // Generate the invoice HTML
    const invoiceHTML = generateInvoiceHTML();

    // Create a Blob with the HTML content
    const blob = new Blob([invoiceHTML], { type: 'text/html' });
    const url = URL.createObjectURL(blob);

    // Open the HTML in a new window for printing to PDF
    const printWindow = window.open(url, '_blank');

    if (printWindow) {
      printWindow.onload = () => {
        printWindow.document.title = `Invoice-${invoice.id}`;
        printWindow.print(); // This will open the print dialog where user can save as PDF
      };
    } else {
      // If popup is blocked, offer direct download as HTML
      const link = document.createElement('a');
      link.href = url;
      link.download = `Invoice-${invoice.id}.html`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      alert("Please save the HTML file and open it in a browser to print as PDF.");
    }

    // Clean up the URL object after a delay
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };

  const formatCurrency = (amount, currency) => {
    const currencySymbols = {
      'Dollar': '$',
      'USD': '$',
      'Euro': '€',
      'EUR': '€',
      'Pound': '£',
      'GBP': '£',
      'Rupee': '₹',
      'INR': '₹'
    };

    const symbol = currencySymbols[currency] || '$';
    return `${symbol}${parseFloat(amount).toFixed(2)}`;
  };


  const getStatusBadge = (status) => {
    const statusConfig = {
      'paid': {
        bgColor: 'bg-green-100',
        textColor: 'text-green-800',
        label: 'Paid'
      },
      'pending': {
        bgColor: 'bg-yellow-100',
        textColor: 'text-yellow-800',
        label: 'Pending'
      },
      'overdue': {
        bgColor: 'bg-red-100',
        textColor: 'text-red-800',
        label: 'Overdue'
      },
      'cancelled': {
        bgColor: 'bg-gray-100',
        textColor: 'text-gray-800',
        label: 'Cancelled'
      }
    };

    const config = statusConfig[status?.toLowerCase()] || statusConfig['pending'];

    return (
      <span className={`inline-flex items-center rounded-md  px-2 py-1 text-xs font-medium  ${config.bgColor} ${config.textColor}`}>
        {config.label}
      </span>
    );
  };

  useEffect(() => {
    const fetchInitialData = async () => {
      let fullUrl = `${COMMON.apiBaseUrl()}/v1/base/${baseId}/setting/invoice?page=1&limit=${allTaskItem.limit}`;

      try {
        setIsLoading(true);
        const response = await _baseRequest(fullUrl, 'GET');

        if (response?.data?.InvoiceList && response?.data?.InvoiceList?.length > 0) {
          setAllTaskItem(response?.data);
        } else {
          setAllTaskItem({
            InvoiceList: [],
            totalTask: 0,
            currentPage: 1,
            hasNextPage: false,
            limit: 25,
            totalInvoice: 1
          });
        }
      } catch (error) {
        console.error("Error fetching initial data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (baseId) {
      fetchInitialData();
    }
  }, [baseId]);

  const formatDueDate = (dateString) => {
    const dueDate = new Date(dateString);
    const today = new Date();

    // Reset time portion for date comparison
    today.setHours(0, 0, 0, 0);
    const dueDateNoTime = new Date(dueDate);
    dueDateNoTime.setHours(0, 0, 0, 0);

    // Format the date part
    const monthDay = dueDate.toLocaleString('default', { month: 'short', day: 'numeric' });
    const weekday = dueDate.toLocaleString('default', { weekday: 'long' });

    // Check if date is today
    if (dueDateNoTime.getTime() === today.getTime()) {
      return (
        <div className="flex flex-row gap-x-1 items-center">
          <span>{monthDay}</span>
          {/* <span className="text-gray-500 text-xs">Today</span> */}
        </div>
      );
    }
    // Check if date is overdue
    else if (dueDateNoTime < today) {
      return (
        <div className="flex flex-row gap-x-1 items-center">
          <span>{monthDay}</span>
          <span className="text-red-500 text-xs">(Overdue)</span>
        </div>
      );
    }
    // Regular future date
    else {
      return (
        <div className="flex flex-row gap-x-1 items-center">
          <span>{monthDay}</span>
          <span className="text-gray-500 text-xs">{weekday}</span>
        </div>
      );
    }
  };


  const handleLoadMore = async () => {
    if (!allTaskItem.hasNextPage) return;

    const nextPage = allTaskItem.currentPage + 1;
    let fullUrl = `${COMMON.apiBaseUrl()}/v1/base/${baseId}/setting/invoice?page=${nextPage}&limit=${allTaskItem.limit}`;

    if (jobId) {
      fullUrl += `&job_id=${jobId}`;
    }


    try {
      setIsLoadingMore(true);
      const response = await _baseRequest(fullUrl, 'GET');

      if (response?.data?.InvoiceList && response?.data?.InvoiceList?.length > 0) {
        setAllTaskItem(prev => ({
          ...response.data,
          InvoiceList: [...prev.InvoiceList, ...response.data.InvoiceList] // Append new tasks to existing ones
        }));
      }
    } catch (error) {
      console.error("Error loading more data:", error);
    } finally {
      setIsLoadingMore(false);
    }
  };


  function classNames(...classes: any) {
    return classes.filter(Boolean).join(' ')
  }


  return (
    <div className="max-w-2xl mx-auto bg-white">



      <div className="flex items-center justify-between gap-y-[6px]">
        <div className='flex flex-col gap-y-1 w-full'>
          <h2 className='text-[20px] lg:text-[24px] font-medium leading-8 text-[#1b1b1b] tracking-[-0.01rem]'>
           Billing Invoices
          </h2>
          <p className='text-sm leading-5 text-[#5c5c5e] font-medium'>
          Review, print, or download your past invoices for your records.
          </p>
        </div>

      </div>

      <div className="bg-[#e0e0e0] w-full h-[1px] my-8"></div>


      <div className="bg-white rounded-lg overflow-hidden border border-solid border-[#0009321f]">

        {/* Header Row */}
        <div className="grid grid-cols-10 gap-4 px-6 py-3 bg-[#00005506] border-b border-gray-200">
          <div className="col-span-3 font-semibold text-[#1c2024] text-sm">Invoice ID</div>
          <div className="col-span-2 font-semibold text-[#1c2024] text-sm">Amount</div>

          <div className="col-span-2 font-semibold text-[#1c2024] text-sm">Date</div>
          <div className="col-span-2 font-semibold text-[#1c2024] text-sm">Status</div>
          <div className="col-span-1 font-semibold text-[#1c2024] text-sm">Actions</div>
        </div>

        {isLoading ? (
          <div className="flex items-center justify-center h-[calc(100vh_-_380px)] w-full">
            <div className="simple-spinner-loader">
              <span></span>
            </div>
          </div>
        ) : !allTaskItem?.InvoiceList?.length ? (
          <div className='w-full mt-0 flex justify-center items-center flex-col gap-y-3' style={{ height: 'calc(100vh - 380px)' }}>
            <ExclamationIcon />
            <p className='text-[#0000007a] text-[13px]'>No task found</p>
          </div>
        ) : (
          // Your existing list rendering code
          allTaskItem.InvoiceList && allTaskItem.InvoiceList.map((invoice, index) => {
            // const cleanedTimeAgo = getShortFormTimeAgo(take.due_by);
            const { image, name } = getSenderDetails(invoice);
            return (
              <div key={index} className="grid grid-cols-10 gap-4 px-6 py-4 border-b border-[#0009321f] last-of-type:border-b-0 hover:bg-gray-50">

                {/* Invoice ID */}
                <div className='col-span-3 flex items-center'>
                  <p className="text-[#1b1b1b] text-[13px] font-medium line-clamp-1">
                    #{invoice?.id}
                  </p>
                </div>

                {/* Amount */}
                <div className="col-span-2 flex items-center">
                  <div className="flex flex-col">
                    <p className="text-[#1b1b1b] text-[13px] font-semibold">
                      {formatCurrency(invoice?.netAmount || invoice?.billableAmount, invoice?.currency)}
                    </p>
                    {invoice?.discount && (
                      <p className="text-[#5c5c5e] text-[11px]">
                        Discount: {formatCurrency(invoice.discount, invoice.currency)}
                      </p>
                    )}
                  </div>
                </div>



                {/* Created Date */}
                <div className="col-span-2 flex items-center">
                  <span className="text-[13px] text-[#1b1b1b]">
                    {formatDueDate(invoice.createdDate)}
                  </span>
                </div>

                {/* Status */}
                <div className="col-span-2 flex items-center">
                  {getStatusBadge(invoice?.status)}
                </div>

                {/* Actions */}
                <div className="col-span-1 flex items-center">
                  <div className="flex gap-x-2">
                    {invoice?.invoicePdf && (
                      <>

                        <button
                          onClick={() => downloadInvoice(invoice)}
                         className="rounded-md duration-200 font-[600] text-[0.8125rem] h-[32px] w-[32px] flex items-center justify-center border border-solid border-[#e7e7e8]"
                       
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="icon icon-tabler icons-tabler-outline icon-tabler-download w-[1rem] h-[1rem] text-[#808080]"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2" />
                            <path d="M7 11l5 5l5 -5" />
                            <path d="M12 4l0 12" />
                          </svg>
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            )
          })
        )}


        {/* Pagination */}
        {allTaskItem.hasNextPage && (
          <div className="px-4 py-3 flex items-center justify-center">
            <button
              onClick={handleLoadMore}
              disabled={isLoadingMore}
              className="text-blue-500 leading-5 text-[12px] rounded-[60px] py-1 hover:ring-1 px-3 ring-inset ring-gray-500/10"
            >
              {isLoadingMore ? (
                <span className="flex items-center gap-x-2">
                  <div className="simple-spinner-load">
                    <span></span>
                  </div>
                  Load More
                </span>
              ) : (
                "Load More"
              )}
            </button>
          </div>
        )}
      </div>

    </div>
  )
}

export default BillingInvoice